import styles from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import { MailListItemDismissButton } from '../index';
import classnamesBind from 'classnames/bind';
import { observer } from 'mobx-react-lite';
import { getDensityModeString } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import { getMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/getMessageListTextStyle';
import * as React from 'react';

const classNames = classnamesBind.bind(styles);

export interface MailListItemPreviewDisplayProps {
    highlightTerms: string[];
    isNudged: boolean;
    previewDisplay: string;
    rowKey: string;
    tableViewId: string;
}

export default observer(function MailListItemPreviewDisplay(
    props: MailListItemPreviewDisplayProps
) {
    const { highlightTerms, isNudged, previewDisplay, rowKey, tableViewId } = props;

    const densityModeString = getDensityModeString();

    const highLightTerms = (element: HTMLElement) => {
        highlightTermsInHtmlElement(
            element,
            highlightTerms,
            false /* separateWordSearch */,
            true /* matchPrefix */
        );
    };

    return (
        <div className={classNames(styles.previewContainer, isNudged && styles.showDismissButton)}>
            <span
                className={classNames(
                    styles.previewDisplayText,
                    isNudged ? styles.isNudged : undefined,
                    isFeatureEnabled('mon-densities') &&
                        getMessageListTextStyle('Major', densityModeString)
                )}
                ref={highLightTerms}>
                {previewDisplay}
            </span>
            {isNudged && <MailListItemDismissButton rowKey={rowKey} tableViewId={tableViewId} />}
        </div>
    );
});
